export function getdata() {
	let obj = {
		searchlist: [{}],
		searchdata: {
			zhongfkm: '',
			cain: '',
		},
		headData: [{
				title: "月",
				prop: "qij",
				width: "30"
			},
			{
				title: "日",
				prop: "pingzrq",
				width: "30",
				type: "date",
				valueformat: 'dd'
			},
			{
				title: "凭证号",
				prop: "pingzh",
				width: "100",
				custom: true,
			},
			{
				title: "系统凭证号",
				prop: "xitpzh",
				width: "100"
			},
			{
				title: "摘要",
				prop: "yuanpzzy1",
				width: "100"
			},
			{
				title: "借方",
				prop: "benbjfje",
				AmountFormat: true,
				width: "100"
			},
			{
				title: "贷方",
				prop: "benbdfje",
				AmountFormat: true,
				width: "100"
			},
			{
				title: "借贷方向",
				prop: "jiedfx",
				width: "100"
			},
			{
				title: "余额",
				prop: "dangqye",
				AmountFormat: true,
				width: "100"
			}
		],
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		}

	}
	return obj
}
